import React from 'react';
import { ReactFragment } from 'react';
import './text-with-icon-layout.scss';

export type Props = {
  text: string;
  renderIcon: () => ReactFragment;
};

export function TextWithIconLayout(props: Props) {
  return (
    <div className="TextWithIconLayout">
      {props.text}

      <div className="icon">{props.renderIcon()}</div>
    </div>
  );
}
